import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function PartnerBoughtGameModal() {
  const { t } = useTranslation();

  return (
    <BaseModal
      className="partner-bought-game-modal"
      description={t("modals.partner_bought_game.desc")}
      descriptionStyle="partner-bought-game-modal__description"
      eventTypeModal={MODAL_TYPES.PARTNER_BOUGHT_GAME}
    ></BaseModal>
  );
}
